import * as React from 'react';
const SvgBin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M19.97 6.27a.52.52 0 0 0-.22-.22.55.55 0 0 0-.25-.05h-3.475v-.6c0-.84 0-1.26-.16-1.58-.14-.28-.37-.51-.661-.66-.32-.16-.74-.16-1.582-.16h-3.204c-.841 0-1.262 0-1.582.16-.28.14-.51.37-.66.66-.161.32-.161.74-.161 1.58V6H4.801c-.28 0-.42 0-.53.05a.52.52 0 0 0-.22.22c-.031.06-.041.12-.051.22v.99c0 .11.02.19.05.25.05.09.12.17.22.22.05.03.11.04.18.05h1.583l.37 7.47c.09 1.6.13 2.39.47 3 .301.53.752.96 1.302 1.23.621.3 1.422.3 3.024.3h1.592c1.602 0 2.403 0 3.024-.3a3.03 3.03 0 0 0 1.301-1.23c.34-.61.38-1.4.471-3l.37-7.47H19s.62 0 .73-.05c.09-.05.17-.12.22-.22C20 7.62 20 7.48 20 7.2v-.4c0-.28 0-.42-.05-.53zM10.008 5h4.005v1h-4.005zm5.597 10.36c-.05.95-.11 1.93-.22 2.13a1 1 0 0 1-.431.41c-.21.1-1.192.1-2.143.1h-1.592c-.951 0-1.932 0-2.143-.1-.18-.09-.33-.23-.43-.41-.11-.2-.17-1.18-.22-2.11L8.056 8h7.919z"
    />
  </svg>
);
export default SvgBin;
